import { CommandBarButton, DefaultButton, IButtonProps } from '@fluentui/react'
import { useContext } from 'react'
import { AppStateContext } from '../../state/AppProvider'

import styles from './Button.module.css'

interface ButtonProps extends IButtonProps {
  onClick: () => void
  text: string | undefined
}

export const ShareButton: React.FC<ButtonProps> = ({ onClick, text }) => {
  const appStateContext = useContext(AppStateContext)
  const ui = appStateContext?.state.frontendSettings?.ui

  const iconColorSelectors = {
    '& i': {
      color: `${ui?.share_button_text_color} !important`
    },
    '.ms-Button-icon': {
      color: `${ui?.share_button_text_color} !important`
    },
    '.ms-Icon': {
      color: `${ui?.share_button_text_color} !important`
    }
  }

  return (
    <CommandBarButton
      className={styles.shareButtonRoot}
      iconProps={{ iconName: 'Share' }}
      onClick={onClick}
      text={text}
      styles={{
        root: {
          background: `${ui?.share_button_color} !important`,
          color: `${ui?.share_button_text_color} !important`,
          selectors: iconColorSelectors
        },
        label: {
          color: `${ui?.share_button_text_color} !important`
        },
        rootHovered: {
          background: `${ui?.share_button_color} !important`,
          opacity: 0.9,
          selectors: iconColorSelectors
        }
      }}
    />
  )
}

export const HistoryButton: React.FC<ButtonProps> = ({ onClick, text }) => {
  return (
    <DefaultButton
      className={styles.historyButtonRoot}
      text={text}
      iconProps={{ iconName: 'History' }}
      onClick={onClick}
      aria-label="Check conversation history button"
    />
  )
}
